<span
  class="switch-toggle {{ sizeMap[size()] }}"
  [class.switch-toggle--error]="isErrorShown()"
  [class.switch-toggle--disabled]="disabled()"
  [class.switch-toggle--no-label-gap]="!labelGap()"
>
  <input
    #checkboxElement
    [id]="id"
    [checked]="checked()"
    [disabled]="disabled()"
    (change)="onChange(checkboxElement)"
    class="switch-toggle__input"
    type="checkbox"
    hidden
  />

  <label [for]="id" class="switch-toggle__label">
    <span>
      <ng-content />
      @if (required()) {
        *
      }
    </span>
    <span class="switch-toggle__slider"></span>
  </label>
</span>
